var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-lg-none"},[_vm._v("hide on screens wider than lg")]),_c('div',{staticClass:"d-none d-lg-block"},[_vm._v("hide on screens smaller than lg")])])
}]

export { render, staticRenderFns }